import InvoiceCascade from './InvoiceCascade';
import LicenseActivatedResult from './LicenseActivatedResult';
import LicensePaywallModal from './LicensePaywallModal';
import TestRestaurant from './TestRestaurant';

export default {
  InvoiceCascade,
  LicenseActivatedResult,
  LicensePaywallModal,
  TestRestaurant,
};
